import React, { useRef, useState } from "react";
import { Header, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import serviceData from "../app/data/serviceData";


export function Service() 
{

  const [action, setAction] = useState(1);
  const [curItem, setCurItem] = useState( serviceData.categories[0] );
  const detailsRef = useRef(null);

  const change = (id) => {
    setAction(id)
    const objet =  serviceData.categories.find( item => item.id === id )
    setCurItem(objet)
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  return(

    <div className='container-fluid' >

      {/* _____________________SECTION HEADER SERVICE ___________________ */} 

      <div className='row'> <TopBar /> </div>
      <div className='row sticky-top'> <Header page={3} /> </div>

      {/* _____________________SECTION 1 SERVICE ___________________ */} 

      <div className='row justify-content-center pt-5'>
        <div className='col-md-10'>
          <div className="d-flex flex-column">
            <h2 className="fw-bold text-dark display-6 mb-2"> NOS SERVICES </h2>
            <span className="p-1 bg-green" style={{ width: '15%' }} ></span>
            <p className="text-muted lead pt-2 d-inline-block">
              Tout ce dont votre entreprise ou structure a besoin, en un seul endroit.
            </p>
          </div>
        </div>
      </div>

      {/* _____________________SECTION 2 SERVICE ___________________ */} 

      <section className="row my-5 justify-content-center">
        <div className="col-xl-10">
          <div className="row g-4">
            { serviceData.categories.map((cat) => (
              <div key={cat.id} className={cat.size}>
                <div className="category-card p-4 d-flex flex-column flex-md-row align-items-center justify-content-between" style={{ backgroundColor: cat.bg }}>
                  <div className="d-flex flex-column text-content">
                    <h3 className="category-title">{cat.title}</h3>
                    <span className="text-secondary">{cat.shortDesc}</span>
                    <div> <button className="btn btn-outline-dark rounded-0 mt-3" onClick={()=> change(cat.id)} >
                      Details <i className="bi bi-chevron-right" ></i>
                    </button> </div>
                  </div>
                  <div className="image-wrapper">
                    <img src={cat.img} alt={cat.title} height={290} className="category-img" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* _____________________SECTION 3 SERVICE ___________________ */} 
      
      <section className='row justify-content-center pt-4' ref={detailsRef}>
        <div className='col-12 px-0'>
           <div className="shop-header-section">
              <div className="bg-light-gray py-5 text-center">
                <h1 className="fw-bold display-6"> Service </h1>
                <div>
                  <span className="lead text-secondary"> Des services fiables et performants </span>
                </div>
              </div>
            </div>
        </div>

        {/* Barre de Filtres et Contrôles */}
        <div className="col-lg-10 mt-5" >
          <div className="row">
            <div className="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-4">
              <div className="d-flex align-items-center gap-3 display-controls">
                <button className={`py-1 px-3 ${(action===1)? 'btn btn-green text-white' : 'btn text-secondary btn-outline-green'}`} onClick={()=> change(1)}> 1 </button>
                <button className={`py-1 px-3 ${(action===2)? 'btn btn-green text-white' : 'btn text-secondary btn-outline-green'}`} onClick={()=> change(2)}> 2 </button>
                <button className={`py-1 px-3 ${(action===3)? 'btn btn-green text-white' : 'btn text-secondary btn-outline-green'}`} onClick={()=> change(3)}> 3 </button>
                <button className={`py-1 px-3 ${(action===4)? 'btn btn-green text-white' : 'btn text-secondary btn-outline-green'}`} onClick={()=> change(4)}> 4 </button>
                <button className={`py-1 px-3 ${(action===5)? 'btn btn-green text-white' : 'btn text-secondary btn-outline-green'}`} onClick={()=> change(5)}> 5 </button>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* _____________________SECTION 4 SERVICE ___________________ */} 

      <section className='row justify-content-center' >
        <div className='col-lg-10 mb-5'>
          <div className="d-flex flex-column border shadow-sm bg-light">
            <span style={{ borderTop: '20px solid #e5e8eb', borderLeft:'20px solid #e5e8eb', width:'50px', height:'50px' } } >  </span> 
            <div className="d-flex align-items-center p-4"> 
              <span className="text-secondary btn-green text-white py-1 px-3"> { action } </span>
              <span className="text-dark px-3 h3"> { curItem.title } </span>
            </div>
            <div className="d-flex align-items-center p-4"> 
              <p className="text-muted">  
                { curItem.longDesc }
              </p>
            </div>
            <span className="align-self-end" style={{ borderBottom: '20px solid #e5e8eb', borderRight:'20px solid #e5e8eb', width:'50px', height:'50px' }} >  </span>
          </div>
        </div>
      </section>

     {/* _____________________SECTION 5 SERVICE ___________________ */} 

      <section className="row mt-5 py-5 justify-content-center bg-light-gray">
        <div className="col-md-11">
          <div className="row g-4">
            { serviceData.services.map((cat) => (
              <div className="col-sm-6 col-lg-3" key={cat.id}>
                <div className="border rounded-3 d-flex flex-column align-items-center p-4">
                  <i className="bi bi-check-circle display-5 lead text-secondary"> </i>
                  <div className="card-body pt-4">
                      <p className="text-secondary lead"> { cat.title } </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    
      {/* _____________________SECTION FOOTER SERVICE ___________________ */} 

      <div className='row'>
        <Footer />
      </div>
      
    </div>

  )
}

